import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { client } from "../../../configs/client";

export const profileUpdate = createAsyncThunk(
  "users/profile-update",

  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.patch(`users/update-profile`, payload);

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const getProfileData = createAsyncThunk(
  "users/get",

  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.get(`users/${payload}`);

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateProfileImage = createAsyncThunk(
  "users/update-image",

  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await client.patch(`users/update-image`, payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (error) {
      console.log(error);
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const userSlice = createSlice({
  name: "user",
  initialState: {
    user: null,
    isLoading: false,
    error: null,
    isFetching: false,
    isImgUpdating: false,
  },

  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(profileUpdate.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(profileUpdate.fulfilled, (state, action) => {
        state.isLoading = false;
        state.user = action.payload.result;
      })
      .addCase(profileUpdate.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateProfileImage.pending, (state) => {
        state.isImgUpdating = true;
      })
      .addCase(updateProfileImage.fulfilled, (state, action) => {
        state.isImgUpdating = false;
        state.user = action.payload?.result;
      })
      .addCase(updateProfileImage.rejected, (state, action) => {
        state.isImgUpdating = false;
        state.error = action.payload;
      })
      .addCase(getProfileData.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getProfileData.fulfilled, (state, action) => {
        state.isFetching = false;
        state.user = action.payload?.result;
      })
      .addCase(getProfileData.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
      });
  },
});

export default userSlice.reducer;
